import React, { useState } from 'react'
//Bibliotecas
import styled from 'styled-components'
import parse from 'html-react-parser';
//Componentes

//Imágenes
import { Flag, ChevronDown, ChevronUp, MousePointer} from 'react-feather';

function Description({ step }) {
    const [scratch, setScratch] = useState(false);


    return (
        <StepDescription>
            <h3>{step.titulo}</h3>
            <span>{parse(step.paso)}</span>
            {step?.scratch &&
                <button onClick={() => setScratch(!scratch)}><Flag />{scratch?"Cerrar":"Probar"}{scratch?<ChevronUp/>:<ChevronDown/>}</button>
            }
            {scratch &&
            <iframe src={step?.scratch}></iframe>
            }
            {step?.button &&
                <button><a href={step?.button?.url} target="_blank" ><MousePointer></MousePointer>{step?.button?.texto}</a></button>
            }
        </StepDescription>
    )
}

export default Description

const StepDescription = styled.div` 
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        align-self:space-between;
        padding:32px 0px;
        height:100%;

        h3{
            margin-bottom:32px; 
            color:var(--color-blanco);
        }

        iframe{
            height: 350px;
            width:400px;
            border-radius:32px;
        }

        button{
            margin-top:16px;
            display:flex;
            flex-direction:row;
            justify-content:center;
            align-items:center;
            padding:8px 16px;
            background-color: transparent;
            border-radius:10px;
            color:var(--color-blanco);
            border: 2px solid var(--color-blanco);
            transition: all 0.3s;
            font-weight:700;
            cursor: pointer;

            &:hover{
                background-color:var(--color-blanco);
                color:var(--color-negro);
                a{
                color:var(--color-negro);
                }
            }


            svg:nth-child(1){
                fill:#4CBF56;   
                color:#45993D;
                margin-right:16px;
            }

            svg:nth-child(2){
                margin-left:8px;
            }

            a{
                color:var(--color-blanco);
                text-decoration:none;
                display:flex;
                justify-content:center;
                align-items:center;
            }
            
        }

        span{
            a{
                color:var(--color-azul-claro);
                cursor: pointer;
            }
        }
`;